// Author: ABLE Dev
export function printTrigger(trigger) {
  const printBtn = trigger;
  printBtn.addEventListener('click', printerPage );
}

function printerPage(e) {
  e.preventDefault();
  window.print()
}